/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExportExcelParameterDto
 */
export interface ExportExcelParameterDto {
    /**
     * 
     * @type {string}
     * @memberof ExportExcelParameterDto
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExportExcelParameterDto
     */
    value?: string | null;
}

/**
 * Check if a given object implements the ExportExcelParameterDto interface.
 */
export function instanceOfExportExcelParameterDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExportExcelParameterDtoFromJSON(json: any): ExportExcelParameterDto {
    return ExportExcelParameterDtoFromJSONTyped(json, false);
}

export function ExportExcelParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportExcelParameterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function ExportExcelParameterDtoToJSON(value?: ExportExcelParameterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'value': value.value,
    };
}

